import type { ComponentProps } from 'react';

type RtlLivingLogoProps = ComponentProps<'svg'> & {
  readonly colors?: [string, string, string, string];
};

const RtlLivingLogo = ({ colors, ...props }: RtlLivingLogoProps) => {
  return (
    <svg viewBox="0 0 72 24" focusable="false" role="img" {...props}>
      <title>RTL Living</title>
      <path fill={colors?.[0] ?? '#ff5c01'} d="M72 0H49.498v12.606H72z" />
      <path fill={colors?.[0] === '#ffffff' ? '#000' : '#fff'} d="M56.491 2.897h1.562v5.467h6.954v1.343H56.49z" />
      <path fill={colors?.[1] ?? '#ec33ec'} d="M47.252 0H24.75v12.606h22.502z" />
      <path
        fill={colors?.[1] === '#ffffff' ? '#000' : '#fff'}
        d="M35.218 4.24h-3.954V2.897h9.473V4.24h-3.955v5.468h-1.564z"
      />
      <path fill={colors?.[2] ?? '#edc00c'} d="M22.502 0H0v12.606h22.502z" />
      <path
        fill={colors?.[2] === '#ffffff' ? '#000' : '#fff'}
        d="M6.391 2.897h5.996c1.826 0 2.842.818 2.842 2.189 0 1.177-.762 1.966-2.06 2.15l2.94 2.472h-2.256l-2.764-2.384H7.955v2.383H6.393v-6.81zm5.792 3.152c.967 0 1.435-.312 1.435-.944 0-.633-.468-.935-1.435-.935H7.955v1.877h4.228z"
      />
      <path
        fill={colors?.[3] ?? '#050508'}
        d="M19.37 23.894v-6.806h1.249v5.718h3.602v1.09H19.37zM25.296 23.894v-6.806h1.25v6.806zM30.197 23.894l-2.645-6.71v-.097h1.357l1.972 5.349h.04l1.941-5.349h1.386v.097l-2.645 6.71zM35.274 23.894v-6.806h1.25v6.806zM38.504 23.894v-6.806h1.445l3.32 4.93h.04v-4.93h1.24v6.806h-1.436l-3.32-4.9h-.04v4.9zM45.963 20.5c0-2.14 1.298-3.52 3.446-3.52 1.786 0 2.977.963 3.144 2.383h-1.26c-.145-.778-.79-1.274-1.884-1.274-1.425 0-2.176.914-2.176 2.411 0 1.498.75 2.393 2.186 2.393 1.171 0 1.845-.623 1.952-1.566h-1.708v-1.08h2.967v.67c0 1.848-1.21 3.083-3.211 3.083-2.148.002-3.456-1.36-3.456-3.5"
      />
    </svg>
  );
};

export default RtlLivingLogo;
